<template>
  <div class="loading-css" v-show="status">
    <div class="vertical-centered-box">
      <div class="content">
        <div class="loader-circle2">
          <img :src="img" :width="width">
        </div>
        <div class="loader-line-mask">
          <div class="loader-line"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: Boolean
    },
    img: {
      type: String,
      default: require('assets/img/loading_logo.png')
    },
    width: {
      type: String,
      default: '100px'
    }
  }
}
</script>

<style lang="scss" scoped>
  .loading-css {
    background-color:rgba(0,0,0,0.3);
    width:100%;
    height:100%;
    position:fixed;
    left:0;
    top:0;
    z-index:10;
    /*z-index: 9000;*/
  }

  .vertical-centered-box {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
  }
  .vertical-centered-box:after {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    margin-right: -0.25em;
  }
  .vertical-centered-box .content {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: middle;
    text-align: left;
    font-size: 0;
  }
  .loader-circle2 {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    box-shadow: inset 0 0 0 3px #000;
    margin-left: -50px;
    margin-top: -50px;

    img {
      position: absolute;
      /*left: 20%;*/
      /*top: 25%;*/
    }
  }
  .loader-line-mask {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 45px;
    height: 95px;
    margin-left: -47px;
    margin-top: -47px;
    overflow: hidden;
    -webkit-transform-origin: 47px 47px;
    -moz-transform-origin: 47px 47px;
    -ms-transform-origin: 47px 47px;
    -o-transform-origin: 47px 47px;
    transform-origin: 47px 47px;
    -webkit-mask-image: -webkit-linear-gradient(top, #000000, rgba(0, 0, 0, 0));
    -webkit-animation: rotate 1.2s infinite linear;
    -moz-animation: rotate 1.2s infinite linear;
    -o-animation: rotate 1.2s infinite linear;
    animation: rotate 1.2s infinite linear;
  }
  .loader-line-mask .loader-line {
    width: 95px;
    height: 95px;
    border-radius: 50%;
    box-shadow: inset 0 0 0 3px #fccf00;
  }

  @-webkit-keyframes rotate{ 0% { -webkit-transform: rotate(0deg);} 100% { -webkit-transform: rotate(360deg);}}
  @-moz-keyframes rotate{ 0% { -moz-transform: rotate(0deg);} 100% { -moz-transform: rotate(360deg);}}
  @-o-keyframes rotate{ 0% { -o-transform: rotate(0deg);} 100% { -o-transform: rotate(360deg);}}
  @keyframes rotate{ 0% {-webkit-transform: rotate(0deg);-moz-transform: rotate(0deg);-ms-transform: rotate(0deg);transform: rotate(0deg);} 100% {-webkit-transform: rotate(360deg);-moz-transform: rotate(360deg);-ms-transform: rotate(360deg);transform: rotate(360deg);}}
</style>
